import { Component, Input, OnInit } from '@angular/core';
import { GarantiazPerfilCrezcamos } from '../../../../../_models/perfil-cliente/garantias-perfil-crezcamos';

@Component({
  selector: 'app-perfil-crezcamos-total-garantias',
  templateUrl: './perfil-crezcamos-total-garantias.component.html',
  styleUrls: ['./perfil-crezcamos-total-garantias.component.scss']
})
export class PerfilCrezcamosTotalGarantiasComponent implements OnInit {
  @Input() informacionPerfil: any;
  data : GarantiazPerfilCrezcamos;
  unifiedGarantias: any[] = [];
  public banNoInformacion: boolean = false;

  ngOnInit(){

    if( this.informacionPerfil && this.informacionPerfil.listadoGarantiasDTO && this.informacionPerfil.listadoGarantiasDTO.mensaje ) {
      this.banNoInformacion = true;
      return;
    }

    if (this.informacionPerfil && this.informacionPerfil.listadoGarantiasDTO) {
      this.data = this.informacionPerfil.listadoGarantiasDTO;

      if (this.data && this.data.garantiasHogar && this.data.garantiasHogar.respaldosCategoriasDTOS && this.data.garantiasHogar.respaldosCategoriasDTOS.length > 0) {
        this.unifiedGarantias.push({
          label: 'PERFILCREZCAMOS.LBL_ACTIVOSHOGAR',
          valorTotal: this.data.garantiasHogar.valorTotal,
          respaldosCategoriasDTOS: this.data.garantiasHogar.respaldosCategoriasDTOS
        });
      }

      if (this.data && this.data.garantiasNegocio && this.data.garantiasNegocio.respaldosCategoriasDTOS && this.data.garantiasNegocio.respaldosCategoriasDTOS.length > 0) {
        this.unifiedGarantias.push({
          label: 'PERFILCREZCAMOS.LBL_ACTIVOSNEGOCIO',
          valorTotal: this.data.garantiasNegocio.valorTotal,
          respaldosCategoriasDTOS: this.data.garantiasNegocio.respaldosCategoriasDTOS
        });
      }
    }
  }  
 }
